export enum DefaultValueType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  SELECTABLE = 'SELECTABLE',
  STRING = 'STRING',
}
